export default {
    getCategories(store) {
        const categories = store.getters.getSearchNavigationCategories.Category || [];
        return categories.map(item => ({
            name: item.name, // Todo: remove it later
            title: item.name,
            slug: item.slug,
            link: item.children.length ? null : `/codes/${item.slug}`,
            component: item.children.length ? item.slug : null,
            children: item.children,
            active: true
        }));
    },

    getLocations(store) {
        const locations = store.getters.getSearchNavigationCategories.Location || [];

        return [
            {
                name: 'Locations', // Todo: remove it later
                title: 'Locations',
                slug: 'locations',
                link:  null,
                component: 'locations',
                children: locations,
                active: true,
                hideBrowseAll: true
            }
        ];
    },

    getAllLinks(store, sortedCategories) { //Todo: remove sortedCategories later
        let links = this.getCategories(store);
        links = [...links, ...this.getLocations(store)];
        return sortedCategories(links, 'title');
    },
};